import Gmap2PointLinkCreateUI from './components/Gmap2PointLinkCreateUI/App';

// 即時関数が必要な場合は IIFE で包む
(() => {
  const appElement = document.querySelector<HTMLElement>('.js-access-gmap-2point-link-create-ui');

  if (appElement) {
    const locale = appElement.dataset.locale || 'ja';

    new Gmap2PointLinkCreateUI({
      appSelector: '.js-access-gmap-2point-link-create-ui',
      locale,
    });
  }
})();
